export function ChatPanel({ children }: { children: React.ReactNode }) {
  return (
    <main className="flex-1 flex flex-col min-w-0 h-full">
      {children}
    </main>
  )
}
